<template>
  <div>
    <div v-if="checkProgress === false">
      <el-form
        ref="abnormalPackageMarkRef"
        :model="abnormalPackageMarkForm"
        label-position="top"
        size="small"
      >
        <el-row :gutter="10">
          <el-col :span="24">
            <!--运单号/扫描单号-->
            <el-form-item
              :label="$t('Resource.anJunWaybillNumber')"
              prop="waybillNumber"
              :rules="{
                required: true,
                message: $t('collectionCenter.notNull'),
                trigger: ['blur']
              }"
            >
              <el-input v-model="abnormalPackageMarkForm.waybillNumber" type="textarea" :rows="5" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!--异常原因-->
            <el-form-item
              :label="$t('collectionCenter.ReasonForAbnormal')"
              prop="reasonForAbnormal"
              :rules="{
                required: true,
                message: $t('collectionCenter.notNull'),
                trigger: ['blur', 'change']
              }"
            >
              <el-select
                v-model="abnormalPackageMarkForm.reasonForAbnormal"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                style="width: 100%"
              >
                <el-option :key="1" :label="$t('collectionCenter.CustomerRequiresInterceptionReturn')" value="customer_reject" /><!-- 客户要求拦截退回 -->
                <el-option :key="2" :label="$t('collectionCenter.ReceivingCustomerRejectsReturn')" value="intercept_return" /><!-- 收方客户拒收退回 -->
                <el-option :key="3" :label="$t('collectionCenter.PackageDamagedReturn')" value="damage_return" /><!-- 包裹破损退回 -->
                <el-option :key="4" :label="$t('collectionCenter.PackageLost')" value="lost_return" /><!-- 包裹遗失 -->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!--异常备注-->
            <el-form-item
              :label="$t('collectionCenter.AbnormalRemarks')"
              prop="remark"
              :rules="{
                required: true,
                message: $t('collectionCenter.notNull'),
                trigger: ['blur']
              }"
            >
              <el-input
                v-model="abnormalPackageMarkForm.remark"
                type="textarea"
                show-word-limit
                :maxlength="200"
                :rows="5"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div v-if="checkProgress === true" style="padding: 20px 0">
      <div style="text-align: right">{{ abnormalPackageMarkResult.percentage }}%</div>
      <el-progress
        :show-text="false"
        :text-inside="false"
        :stroke-width="20"
        :percentage="abnormalPackageMarkResult.percentage"
        status="success"
      />
      <div v-if="abnormalPackageMarkResult.percentage === 100" style="font-size: 16px">
        <div style="margin: 20px 0;">
          <span style="margin-right: 20px;">{{ $t('GlobalSetObj.succeed') }}：<span style="color: #67c23a">{{ abnormalPackageMarkResult.success }}</span></span>
          <span>{{ $t('GlobalSetObj.Lose') }}：<span style="color: #bd2c00">{{ abnormalPackageMarkResult.fail }}</span></span>
        </div>
        <div v-if="abnormalPackageMarkResult.errorList.length > 0">
          <div style="margin-bottom: 6px;">{{ $t('collectionCenter.FailureDetails') }}：</div>
          <div style="max-height: 200px;overflow-y: auto;">
            <div v-for="(item, index) in abnormalPackageMarkResult.errorList" :key="index">{{ item }}</div>
          </div>
        </div>
      </div>
    </div>
    <div style="text-align: right">
      <el-button size="small" @click="confirmAbnormalPackageMarkData(1)">
        {{ $t('orderExport.close') }}
      </el-button>
      <el-button
        v-if="checkProgress === false"
        size="small"
        type="primary"
        @click="confirmAbnormalPackageMarkData(2)"
      >
        {{ $t('collectionCenter.confirm') }}
      </el-button>
    </div>
  </div>
</template>
<script>
import { modifyExceptionPackage } from '@/api/bulkExpressApi';

export default {
  name: 'AbnormalPackageMark',
  data() {
    return {
      checkProgress: false,
      abnormalPackageMarkForm: {
        waybillNumber: '',
        reasonForAbnormal: null,
        remark: ''
      },
      abnormalPackageMarkResult: {
        all: 0,
        success: 0,
        fail: 0,
        percentage: 0,
        errorList: []
      }
    };
  },
  methods: {
    // 确定提交异常包裹标记数据
    confirmAbnormalPackageMarkData(type) {
      if (type === 1) {
        this.$emit('updateTable', this.checkProgress);
      } else {
        this.$refs.abnormalPackageMarkRef.validate(valid => {
          if (valid) {
            const arrList = [];
            const arr = this.abnormalPackageMarkForm.waybillNumber.split(/\r?\n/).map(item => item.replace(/\s+/g, '')).filter(item => Boolean(item));
            arr.map(item => {
              if (item && arrList.includes(item) === false) {
                arrList.push(item);
              }
            });
            const param = {
              numbers: arrList,
              abnormalType: this.abnormalPackageMarkForm.reasonForAbnormal,
              abnormalRemark: this.abnormalPackageMarkForm.remark
            };
            modifyExceptionPackage(param).then(res => {
              if (res.code === 200) {
                this.checkProgress = true;
                this.abnormalPackageMarkResult = {
                  all: res.data.data.totalProcessed,
                  success: res.data.data.successCount,
                  fail: res.data.data.failureCount,
                  percentage: 0,
                  errorList: res.data.data.failureDetails
                };
                const time = setInterval(() => {
                  if (this.abnormalPackageMarkResult.percentage < 100) {
                    this.abnormalPackageMarkResult.percentage++;
                  }
                  if (this.abnormalPackageMarkResult.percentage >= 100) {
                    clearInterval(time);
                  }
                }, 50);
              }
            });
          }
        });
      }
    }
  }
};
</script>
<style scoped>

</style>
